import { createFileRoute } from '@tanstack/react-router'
import ApisManagement from '@/components/Apis'

export const Route = createFileRoute('/_authenticated/apis/')({
  component: () => <ApisManagement />,
})
